/**
 * Agrupa product_items por produto + organização + endereço.
 * Localização, categoria e condição não devem criar cards separados
 * no modal de insumos disponíveis.
 */
export const groupProductItemsByOrganizationAndAddress = (productItems = []) => {
  if (!Array.isArray(productItems)) return []

  const groups = new Map()

  productItems.forEach((productItem) => {
    const organizationId =
      productItem.organization_id ?? productItem.address?.addressable_id ?? 'null'
    const addressId = productItem.address_id ?? productItem.address?.id ?? 'null'
    const key = `${productItem.product_id ?? 'product'}-${organizationId}-${addressId}`
    const quantity = Number(productItem.quantity) || 0
    const locationKey = String(
      productItem.location_id ?? productItem.location?.id ?? 'no-location'
    )
    const locationLabel =
      productItem.location?.formatted_location || 'Sem localização'

    if (!groups.has(key)) {
      groups.set(key, {
        representative: productItem,
        representativeQuantity: quantity,
        quantity,
        locations: new Map([
          [locationKey, { id: locationKey, label: locationLabel, quantity }],
        ]),
      })
      return
    }

    const group = groups.get(key)
    group.quantity += quantity
    const location = group.locations.get(locationKey)
    if (location) {
      location.quantity += quantity
    } else {
      group.locations.set(locationKey, {
        id: locationKey,
        label: locationLabel,
        quantity,
      })
    }

    if (quantity > group.representativeQuantity) {
      group.representative = productItem
      group.representativeQuantity = quantity
    }
  })

  return Array.from(groups.values()).map((group) => {
    const locations = Array.from(group.locations.values())
    const hasMultipleLocations = locations.length > 1
    const locationsText = locations.map(({ label }) => label).join(' ')

    return {
      ...group.representative,
      quantity: group.quantity,
      _locations: locations,
      ...(hasMultipleLocations && {
        location: {
          formatted_location: `Múltiplas localizações (${locations.length})`,
        },
      }),
      _locationsText: locationsText,
    }
  })
}
